import { Locales, type LocaleCode } from '@/constants/commons'

/** 舊的 i18n code 或其他可能的語系格式 需 308 轉址 */
const redirect308Mapping: Record<any, string> = {
  zh: Locales.TW,
  tw: Locales.TW,
  cn: Locales.CN,
  jp: Locales.JA,
}

export default defineNuxtRouteMiddleware(async to => {
  const nuxtApp = useNuxtApp()
  const { loadLocaleMessages } = useLocaleMessages()
  const [_, prefix = ''] = to.path.split('/')

  const regionRegex = /(\d+)(-.*)/
  if (regionRegex.test(prefix as string)) {
    // /1-Taipei 舊版網頁地區頁面網址
    const matches = regionRegex.exec(prefix)!
    return navigateTo(nuxtApp.$localePath(`/regions/${matches[1]}`), { replace: true, redirectCode: 301 })
  }

  const digitalRegex = /(\d+)/
  if (digitalRegex.test(prefix)) {
    // /:id 錯誤網址導向商品頁面
    const matches = digitalRegex.exec(prefix)!
    return navigateTo(nuxtApp.$localePath(`/products/${matches[1]}`), { replace: true, redirectCode: 301 })
  }

  /**
   * 有帶語系 prefix 的網址
   * 管 cookie 或瀏覽器語系為何，都顯示該 prefix 的語言
   * ex: /ja/* 就是顯示日文
   * 若使用者直接輸入網址或是點其他連結，開啟了有帶語系的網址，**不會**記錄/覆寫 cookie 中的語系偏好
   */
  if (nuxtApp.$i18n?.localeCodes?.value?.includes(prefix as LocaleCode)) {
    if (nuxtApp.$i18n.locale.value === prefix) {
      return
    }
    /** 以 url locale 為準 */
    await loadLocaleMessages(prefix)
    nuxtApp.$i18n.setLocale(prefix as LocaleCode)
  }

  /**
   * 語系調整
   * 原 cn -> zh-cn
   * 原 jp -> ja
   * 若是原本的路徑，則要 308 轉導至新的路徑
   */
  const redirectLocale = redirect308Mapping[prefix.toLocaleLowerCase()]
  if (redirectLocale) {
    return navigateTo(to.fullPath.replace(prefix, redirectLocale), { redirectCode: 308, replace: true })
  }
})
